import { Component, Input } from '@angular/core';
import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { BaseRules, TextValues } from './minnesota.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-minnesota',
  templateUrl: './minnesota.component.html',
  styleUrls: ['./minnesota.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    TruncateModule,
    TooltipModule,
  ],
})
export class MinnesotaComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('minnesota', form);
    }
  }

  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('minnesota', null);
    }
  }

  optionsSelection = {
    Total_Medical_Expenses: '',
    Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss:
      '',
    Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions:
      '',
    Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services:
      '',
  };

  hideOptionsDropdown = false;

  override eventHook(value: any): void {
    if (value === 'StateMinimumLimit_LevelOne_Radio') {
      this.hideOptionsDropdown = true;
      this.optionsSelection.Total_Medical_Expenses = '$20,000';
      this.optionsSelection.Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss =
        '';
      this.optionsSelection.Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions =
        '$500';
      this.optionsSelection.Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services =
        '$200';
      this.reactiveForm.get('OPTIONS_DropDown')?.setValue(null);
      this.reactiveForm.get('OPTIONS_DropDown').updateValueAndValidity();
    } else {
      this.optionsSelection = {
        Total_Medical_Expenses: '',
        Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss:
          '',
        Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions:
          '',
        Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services:
          '',
      };
      this.hideOptionsDropdown = false;
    }
  }
  override setupHookForDropDownData(): void {
    setTimeout(() => {
      const levelOneRadio = this.reactiveForm.get('levelOne_Radio');
      const pipOptionsDropdown = this.reactiveForm.get('OPTIONS_DropDown');

      const hasExistingRadioSelection =
        !!levelOneRadio?.value && levelOneRadio.value !== '';
      const hasExistingDropdownSelection =
        !!pipOptionsDropdown?.value && pipOptionsDropdown.value !== '';

      if (
        this.baseRules['MaxLimits_Options'] === 'show' ||
        this.baseRules['VaryByState_Options'] === 'show'
      ) {
        if (levelOneRadio && !hasExistingRadioSelection) {
          levelOneRadio.setValue('IncreaseMinimumLimit_LevelOne_Radio');
          levelOneRadio.updateValueAndValidity();
        }
      }
      if (this.baseRules['MaxLimits_Options'] === 'show') {
        if (pipOptionsDropdown) {
          const currentRadioValue = levelOneRadio?.value;
          const canApplyDefaultDropdown =
            !hasExistingDropdownSelection &&
            currentRadioValue !== 'StateMinimumLimit_LevelOne_Radio';

          if (canApplyDefaultDropdown) {
            pipOptionsDropdown.setValue('Option 6');
            pipOptionsDropdown.updateValueAndValidity();
            this.optionsSelection.Total_Medical_Expenses = '$100,000';
            this.optionsSelection.Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss =
              '$50,000';
            this.optionsSelection.Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions =
              '$800';
            this.optionsSelection.Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services =
              '$300';
          }
        }
      }
      if (pipOptionsDropdown.value) {
        this.updateOptionsFromDropdown(pipOptionsDropdown.value);
      }
    }, 0);
  }
  override dynamicRuleQueryBuilder(): string {
    const selectionId = this.baseRules['selectionId'];
    // Combine all ShowAllOptions conditions
    if (
      selectionId ===
        'AcceptCoverage_RejectAdditionalPIP_MinimumLimitsRequired' ||
      selectionId === 'AcceptCoverage_VaryByState_MinimumLimitsRequired' ||
      selectionId === 'AcceptCoverage_AcceptAdditionalPIP_MinimumLimitsRequired'
    ) {
      return 'ShowAllOptions';
    }
    if (
      selectionId ===
        'AcceptCoverage_RejectAdditionalPIP_MaximumLimitsAvailable' ||
      selectionId === 'AcceptCoverage_VaryByState_MaximumLimitsAvailable' ||
      selectionId ===
        'AcceptCoverage_AcceptAdditionalPIP_MaximumLimitsAvailable'
    ) {
      return 'ShowAllOptionsWithOption6';
    }
  }

  private updateOptionsFromDropdown(selectedValue: any): void {
    if (!this.controls || !this.controls[1] || !this.controls[1].data) {
      return;
    }

    // Get the option name (handle both string "Option 1" and object {name: "Option 1"} formats)
    const optionName =
      typeof selectedValue === 'string' ? selectedValue : selectedValue?.name;

    if (!optionName) return;

    // Find the matching option in controls[1].data
    const selectedOption: any = this.controls[1].data.find(
      (option: any) => option.name === optionName,
    );

    if (selectedOption) {
      // Update the local variable with values from the selected option
      this.optionsSelection = {
        Total_Medical_Expenses: selectedOption.Total_Medical_Expenses || '',
        Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss:
          selectedOption.Total_Aggregate_Work_Loss_Essential_Services_Expenses_Funeral_Expenses_And_Survivors_Loss ||
          '',
        Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions:
          selectedOption.Total_Weekly_Maximum_Work_Loss_Or_Survivors_Loss_For_Loss_Of_Contributions ||
          '',
        Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services:
          selectedOption.Total_Weekly_Maximum_Essential_Services_Or_Survivors_Loss_For_Substitute_Services ||
          '',
      };
    }
  }
}
